import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const BlueQrCodeLanding = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    {...props}
    width={65}
    height={65}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
  >
    <circle cx={32.5} cy={32.5} r={32.5} fill="#38B6FF" fillOpacity={0.17} />

    <g transform="translate(16.5,18)">
      <path
        d="M11.643 13.8948H7.85782C6.85164 13.8948 6.03711 13.0803 6.03711 12.0741V8.28897C6.03711 7.28279 6.85164 6.46826 7.85782 6.46826H11.643C12.6492 6.46826 13.4637 7.28279 13.4637 8.28897V12.0741C13.4637 13.0803 12.6492 13.8948 11.643 13.8948ZM7.80991 7.90566C7.61825 7.90566 7.4266 8.09732 7.4266 8.28897V12.0741C7.4266 12.2658 7.61825 12.4574 7.80991 12.4574H11.5951C11.7867 12.4574 11.9784 12.2658 11.9784 12.0741V8.28897C11.9784 8.09732 11.7867 7.90566 11.5951 7.90566H7.80991Z"
        fill="#38B6FF"
      />
      <path
        d="M23.238 13.8948H19.4528C18.4466 13.8948 17.6321 13.0803 17.6321 12.0741V8.28897C17.6321 7.28279 18.4466 6.46826 19.4528 6.46826H23.238C24.2441 6.46826 25.0587 7.28279 25.0587 8.28897V12.0741C25.0108 13.0803 24.1962 13.8948 23.238 13.8948ZM19.4049 7.90566C19.2132 7.90566 19.0216 8.09732 19.0216 8.28897V12.0741C19.0216 12.2658 19.2132 12.4574 19.4049 12.4574H23.19C23.3817 12.4574 23.5733 12.2658 23.5733 12.0741V8.28897C23.5733 8.09732 23.3817 7.90566 23.19 7.90566H19.4049Z"
        fill="#38B6FF"
      />
      <path
        d="M11.643 24.5317H7.85782C6.85164 24.5317 6.03711 23.7172 6.03711 22.711V18.9258C6.03711 17.9196 6.85164 17.1051 7.85782 17.1051H11.643C12.6492 17.1051 13.4637 17.9196 13.4637 18.9258V22.711C13.4637 23.7172 12.6492 24.5317 11.643 24.5317ZM7.80991 18.5425C7.61825 18.5425 7.4266 18.7342 7.4266 18.9258V22.711C7.4266 22.9026 7.61825 23.0943 7.80991 23.0943H11.5951C11.7867 23.0943 11.9784 22.9026 11.9784 22.711V18.9258C11.9784 18.7342 11.7867 18.5425 11.5951 18.5425H7.80991Z"
        fill="#38B6FF"
      />
      <path
        d="M23.238 24.5317H19.4528C18.4466 24.5317 17.6321 23.7172 17.6321 22.711V18.9258C17.6321 17.9196 18.4466 17.1051 19.4528 17.1051H23.238C24.2441 17.1051 25.0587 17.9196 25.0587 18.9258V22.711C25.0108 23.7172 24.1962 24.5317 23.238 24.5317ZM19.4049 18.5425C19.2132 18.5425 19.0216 18.7342 19.0216 18.9258V22.711C19.0216 22.9026 19.2132 23.0943 19.4049 23.0943H23.19C23.3817 23.0943 23.5733 22.9026 23.5733 22.711V18.9258C23.5733 18.7342 23.3817 18.5425 23.19 18.5425H19.4049Z"
        fill="#38B6FF"
      />
      <path
        d="M0.718702 11.0201C0.335394 11.0201 0 10.7326 0 10.3014V2.92272C0 1.29366 1.29366 0 2.92272 0H10.3493C10.7326 0 11.0201 0.335394 11.0201 0.718702C11.0201 1.10201 10.7326 1.4374 10.3014 1.4374H2.92272C2.10819 1.4374 1.4374 2.10819 1.4374 2.92272V10.3014C1.4374 10.7326 1.10201 11.0201 0.718702 11.0201Z"
        fill="#38B6FF"
      />
      <path
        d="M30.3293 11.0201C29.946 11.0201 29.6106 10.6847 29.6106 10.3014V2.92272C29.6106 2.10819 28.9398 1.4374 28.1253 1.4374H20.6987C20.3154 1.4374 19.98 1.10201 19.98 0.718702C19.98 0.335394 20.3154 0 20.6987 0H28.0773C29.7064 0 31.0001 1.29366 31.0001 2.92272V10.3014C31.048 10.7326 30.7126 11.0201 30.3293 11.0201Z"
        fill="#38B6FF"
      />
      <path
        d="M28.1253 31H20.6987C20.3154 31 19.98 30.6646 19.98 30.2812C19.98 29.8979 20.3154 29.5625 20.6987 29.5625H28.0774C28.8919 29.5625 29.5627 28.8918 29.5627 28.0772V20.6986C29.5627 20.3153 29.8981 19.9799 30.2814 19.9799C30.6647 19.9799 31.0001 20.3153 31.0001 20.6986V28.0772C31.048 29.7063 29.7064 31 28.1253 31Z"
        fill="#38B6FF"
      />
      <path
        d="M10.3014 31H2.92272C1.29366 31 0 29.7063 0 28.0772V20.6986C0 20.3153 0.335394 19.9799 0.718702 19.9799C1.10201 19.9799 1.4374 20.3153 1.4374 20.6986V28.0772C1.4374 28.8918 2.10819 29.5625 2.92272 29.5625H10.3493C10.7326 29.5625 11.068 29.8979 11.068 30.2812C11.068 30.6646 10.7326 31 10.3014 31Z"
        fill="#38B6FF"
      />
    </g>
    <defs>
      <clipPath id="clip0_11410_731">
        <rect width="31.0479" height="31" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
const ForwardRef = forwardRef(BlueQrCodeLanding);
export default ForwardRef;
